import { BaseError, resolveBaseErrorParams, BaseErrorObject } from "./BaseError";

export enum SaveUserErrorType {
  MissingFirstOrLastName = "MissingFirstOrLastName",
  PasswordLengthInsufficient = "PasswordLengthInsufficient",
  PasswordDoesntContainLowercaseAndUppercaseCharacter = "PasswordDoesntContainLowercaseAndUppercaseCharacter",
  PasswordDoesntContainSpecialCharacter = "PasswordDoesntContainSpecialCharacter",
  PasswordDoesntContainNumber = "PasswordDoesntContainNumber",
  EmailAlreadyUsed = "EmailAlreadyUsed",
  EmailWrongFormat = "EmailWrongFormat",
  MissingPassword = "MissingPassword",
}

export class SaveUserError extends BaseError<SaveUserErrorType> {
  public name: "SaveUserError" = "SaveUserError" as const;
}

export const resolveSaveUserErrorParams = (err: any): BaseErrorObject<SaveUserErrorType> | null =>
  resolveBaseErrorParams<SaveUserErrorType>(err, SaveUserErrorType);
